// extracted by mini-css-extract-plugin
export default {"custommizeTreePermission":"userRoleCUR_custommizeTreePermission__CU7J2"};